import React from 'react';
import './style.scss';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';

const Stepper = ({ items, darkMode }) => (
  <div className={clsx('stepper', darkMode && 'stepper-dark')}>
    {items.map((item, index) => (
      <Step key={index} data={item} index={index + 1} isLast={index === items.length - 1} />
    ))}
  </div>
);

const Step = ({ data, index, isLast }) => {
  // Destructuring fields
  const { heading, text, image } = data.fields;
  // Conditional rendering
  const needHeading = !!text?.value;
  const needText = !!text?.value;
  const needImage = !!image?.value?.src;
  // A helper function to format an index into 2 digits string
  const getLabel = (number) => {
    const string = '' + number;
    if (string.length >= 2) return string;
    return `0${string}`;
  };

  return (
    <div className="stepper-step">
      <div className="step-circle-wrapper">
        <div className="step-circle">
          <div className="step-circle-inner">{getLabel(index)}</div>
        </div>
        {/* If the step is the last step we don't want to separator */}
        {!isLast && (
          <div className="step-circle-separator">
            <div />
          </div>
        )}
      </div>
      <div className="step-desc">
        {needHeading && <Text tag="h4" className="step-desc-title" field={heading} />}
        {needText && <RichText className="step-desc-text" field={text} />}
        {needImage && <Image field={image} className="step-desc-image" />}
      </div>
    </div>
  );
};

export default Stepper;
